import { PLATFORM } from 'aurelia-pal';
import Storax from 'libs/storax';

class AppStorage extends Storax {
  constructor(appConfiguration, appLogger) {
    'inject';

    super(PLATFORM.global, appLogger, false);

    this._appConfiguration = appConfiguration;
    this._initialize();
  }
  _configure() {
    const appName = this._appConfiguration.get('appName');
    const storageKey = this._getStorageKey();
    const key = `${appName}_${storageKey}`;
    return {
      key,
      name: 'appStorage',
      entries: {
        enabled: this._entriesEnabled(),
      },
    };
  }
  _getStorageKey() {
    return this._appConfiguration.get('storageKeys.main');
  }
  _entriesEnabled() {
    return false;
  }
}

export { AppStorage };
